const data = [
	{
		name: 'Familjestånd',
		chartType: 'maritialstatus',
		caption: '',
		tags: [ 'general' ]
	},
	{
		name: 'Åldersgrupper',
		chartType: 'agegroups',
		caption: '',
		tags: [ 'general' ]
	},
	{
		name: 'Kön',
		chartImage: 'bars.png',
		chartType: 'gender',
		caption: '',
		tags: [ 'general' ]
	},
	{
		name: 'Utbildning',
		chartType: 'education',
		caption: '',
		tags: [ 'general' ]
	},
	{
		name: 'Toppföljare per stad',
		chartType: 'topfanspercity',
		caption: '',
		tags: [ 'general' ]
	},
	{
		name: 'Generellt sentiment',
		chartType: 'sentiment-morepositive',
		caption: '',
		tags: [ 'general', 'sentiment' ]
	},
	{
		name: 'Generell aktivitet',
		chartType: 'aera-views-over-time',
		caption: '',
		tags: [ 'general', 'active' ]
	},
	{
		name: 'Generell Dagliga Användare',
		chartType: 'dailyusers',
		caption: '',
		tags: [ 'general', 'active' ]
	},
	{
		name: 'Facebook Sentiment',
		chartType: 'sentiment-morenegative',
		caption: '',
		tags: [ 'facebook', 'sentiment' ]
	},
	{
		name: 'Facebook aktivitet',
		chartType: 'aera-views-over-time',
		caption: '',
		tags: [ 'facebook', 'active' ]
	},
	{
		name: 'Facebook Dagliga Användare',
		chartType: 'dailyusers',
		caption: '',
		tags: [ 'facebook', 'active' ]
	},
	{
		name: 'Twitter Sentiment',
		chartType: 'sentiment-morenegative',
		caption: '',
		tags: [ 'twitter', 'sentiment' ]
	},
	{
		name: 'Twitter aktivitet',
		chartType: 'aera-views-over-time',
		caption: '',
		tags: [ 'twitter', 'active' ]
	},
	{
		name: 'Twitter Dagliga Användare',
		chartType: 'dailyusers',
		caption: '',
		tags: [ 'twitter', 'active' ]
	},
	{
		name: 'LinkedIn Sentiment',
		chartType: 'sentiment-morenegative',
		caption: '',
		tags: [ 'linkedin', 'sentiment' ]
	},
	{
		name: 'LinkedIn aktivitet',
		chartType: 'aera-views-over-time',
		caption: '',
		tags: [ 'linkedin', 'active' ]
	},
	{
		name: 'LinkedIn Dagliga Användare',
		chartType: 'dailyusers',
		caption: '',
		tags: [ 'linkedin', 'active' ]
	},
	{
		name: 'YouTube Sentiment',
		chartType: 'sentiment-morenegative',
		caption: '',
		tags: [ 'youtube', 'sentiment' ]
	},
	{
		name: 'YouTube aktivitet',
		chartType: 'aera-views-over-time',
		caption: '',
		tags: [ 'youtube', 'active' ]
	},
	{
		name: 'Youtube Dagliga Användare',
		chartType: 'dailyusers',
		caption: '',
		tags: [ 'youtube', 'active' ]
	}
];

export default data;
